<template>
    <v-form ref="form">
        <v-row>
            <v-col cols="12" md="3">
                <DatePicker
                    dense
                    label="Date"
                    v-model="form.date"
                    outlined
                    hide-details="auto"
                    :rules="[isRequired]"
                    />
            </v-col>
            <v-col cols="12" md="3">
                <v-autocomplete
                    label="Warehosue"
                    v-model="form.warehouse_id"
                    :items="warehouses"
                    item-text="display_name"
                    item-value="id"
                    dense
                    @update:search-input="searchWarehouses"
                    outlined
                    :rules="[isRequired]"
                    hide-details="auto"
                    ></v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-subheader>Landed Cost Components</v-subheader>
                <LandedCostComponentLine
                    v-for="(d, i) in form.components"
                    :key="d.key"
                    :index="i"
                    @remove="onRemoveCostComponent(i)"
                    :component_id.sync="form.components[i].component_id"
                    :cost.sync="form.components[i].cost"
                    :landed-cost-components.sync="landedCostComponents"
                />
                <v-btn block depressed small @click="onAddCostComponent">
                    <v-icon left>mdi-playlist-plus</v-icon>
                    add landed cost component
                </v-btn>
                <v-simple-table>
                    <tbody>
                        <tr>
                            <th>Total Landed Cost</th>
                            <td class="font-weight-bold">{{formatNumber(totalLandedCost, 2)}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-subheader>Landed Cost Items</v-subheader>
                <LandedCostItemLine
                    ref="LandedCostItemLine"
                    v-for="(d, i) in form.items"
                    :key="d.key"
                    :index="i"
                    @remove="onRemoveItem(i)"

                    :item_id.sync="form.items[i].item_id"
                    :quantity.sync="form.items[i].quantity"
                    :measure_unit_id.sync="form.items[i].measure_unit_id"
                    :unit_value.sync="form.items[i].unit_value"
                    :total_value="form.items[i].total_value"
                    :unit_cost="form.items[i].unit_cost"
                    :total_cost="form.items[i].total_cost"
                    :total_value_with_cost="form.items[i].total_value_with_cost"

                    :items.sync="items"
                    />
                <v-row no-gutters>
                    <v-col cols="12" md="3" class="pe-2">
                        <v-btn block color="primary" depressed small @click="onCopyLines">
                            <v-icon left>mdi-content-copy</v-icon>
                            copy from purchase orders
                        </v-btn>
                    </v-col>
                    <v-col cols="12" md="9">
                        <v-btn block depressed small @click="onAddItem">
                            <v-icon left>mdi-playlist-plus</v-icon>
                            add line
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-textarea
                    label="Remarks"
                    v-model="form.remarks"
                    :rules="[isRequired]"
                    dense
                    outlined
                    hide-details="auto"
                ></v-textarea>
            </v-col>
        </v-row>
        <v-dialog v-model="copyLinesDialog" max-width="800" scrollable>
            <LandedCostPurchaseOrderCopy
                v-if="copyLinesDialog"
                @cancel="copyLinesDialog = false"
                @submit="handleSubmitCopyLines"
                :warehouseId="form.warehouse_id"
                />
        </v-dialog>
    </v-form>
</template>

<script>
import DatePicker from './../common/DatePicker.vue';
import LandedCostComponentLine from './LandedCostComponentLine.vue'
import LandedCostItemLine from './LandedCostItemLine.vue'
import { v4 as uuid } from 'uuid';
import { formatNumber } from 'accounting';
import { getTotal } from './../../utils/accounting';
import warehouse from './../../services/purchase/warehouse';
import LandedCostPurchaseOrderCopy from './LandedCostPurchaseOrderCopy.vue';
import purchaseOrderService from '../../services/purchase/order';
import { isRequired } from './../../utils/validations';

export default {
    components: {
        DatePicker,
        LandedCostComponentLine,
        LandedCostItemLine,
        LandedCostPurchaseOrderCopy
    },
    props: {
        value: Object
    },
    data() {
        return {
            form: {
                id: null,
                warehouse_id: null,
                code: null,
                date: null,
                remarks: "",
                reference: "",
                components: [],
                items: []
            },
            warehouseLoading: false,
            warehouses: [],
            items: [],
            landedCostComponents: [],
            copyLinesDialog: false
        }
    },
    computed: {
        totalLandedCost() {
            return getTotal(this.form.components, "cost");
        }
    },
    watch: {
        form: {
            deep: true,
            handler(form) {
                this.$emit("input", {...form, components: [...form.components], items: [...form.items]});
            }
        }
    },
    methods: {
        formatNumber, isRequired,
        onAddCostComponent() {
            this.form = {
                ...this.form,
                components: [...this.form.components, {
                    component_id: null,
                    cost: 0,
                    key: uuid()
                }]
            }
        },
        onRemoveCostComponent(index) {
            this.form.components.splice(index, 1)
        },
        onAddItem() {
            this.form = {
                ...this.form,
                items: [...this.form.items, {
                    item_id: null,
                    quantity: 0,
                    measure_unit_id: null,
                    unit_value: 0,
                    total_value: 0,
                    unit_cost: 0,
                    total_cost: 0,
                    total_value_with_cost: 0,
                    key: uuid()
                }]
            }
        },
        onRemoveItem(index) {
            this.form.items.splice(index, 1)
        },
        searchWarehouses(query) {
            this.warehouseLoading = true;
            warehouse.search(query).then(res => [
                this.warehouses = [...this.warehouses, ...res.data]
            ]).finally(() => {
                this.warehouseLoading = false;
            })
        },
        onCopyLines() {
            this.copyLinesDialog = true;
        },
        async handleSubmitCopyLines(purchaseOrders) {

            this.copyLinesDialog = false;
            let ids = purchaseOrders.map(each => each.id);

            for(const id of ids) {

                let { data: purchaseOrder } = await purchaseOrderService.findByID(id);

                let purchaseOrderLines = purchaseOrder.lines;
                if(!Array.isArray(purchaseOrderLines)) {
                    console.error(`Purchase order for good receipt ${purchaseOrder.code} doesn't have a lines or lines is not iteratable`);
                    continue;
                }

                for(const line of purchaseOrderLines) {
  
                    this.items = [...this.items, line.item];
                    this.form = {
                        ...this.form,
                        items: [
                            ...this.form.items,
                            {
                                item_id: line.item.id,
                                quantity: line.net_received,
                                measure_unit_id: line.measure_unit.id,
                                unit_value: line.price,
                                total_value: 0,
                                unit_cost: 0,
                                total_cost: 0,
                                total_value_with_cost: 0,
                                key: uuid()
                            },
                        ]
                    }
                }
            }
        }
    },
    created() {
        if(this.value && this.value.id) {
            this.form = {...this.form, ...this.value};

            if(this.form.warehouse) {
                this.warehouses = [...this.warehouses, this.form.warehouse];
            }

            let componentsLines = this.form.components;
            if(Array.isArray(componentsLines)) {
                componentsLines.forEach(line => {
                    this.landedCostComponents = [...this.landedCostComponents, line.component]
                })
            }

            let itemLines = this.form.items;
            if(Array.isArray(itemLines)) {
                itemLines.forEach(line => {
                    this.items = [...this.items, line.item]
                })
            }

            return;
        }
        this.onAddCostComponent();
    },
    updated() {

        // calculate the total value
        this.form.items.forEach(each => {
            each.total_value = each.quantity * each.unit_value;
        })

        // get the sum of total value
        let TotalValue = getTotal(this.form.items, "total_value");
        
        this.form.items.forEach(each => {
            each.total_cost = this.totalLandedCost * (each.total_value / TotalValue);

            if(!each.quantity) {
                return
            }
            each.unit_cost = each.total_cost / each.quantity;
            each.total_value_with_cost = Number(each.total_value) + Number(each.total_cost)
        });
    }
}
</script>

<style>

</style>